module.exports = __webpack_public_path__ + "static/img/img-ywfw.d6b1d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-ywfw.png
// module id = 461
// module chunks = 2